/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
import { connect } from 'react-redux';
import { addTodo } from '../../actions';
//import FilterLink from  './FilterLink';

let AddTodo = ({ dispatch }) => { 
  let input; 
  return ( 
    <form onSubmit={ e => { 
      e.preventDefault(); 
      if (!input.value.trim()) { return } 
      dispatch(addTodo(input.value)); 
      input.value = ''; 
    }}> 
      <input type="text" ref={ node => { input = node } }/> 
      <input type="submit" name="添加" /> 
    </form> 
  );
}

AddTodo = connect()(AddTodo);

export default AddTodo;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/todos/AddTodo.js